const DOCUMENTS = ['documents', 'documents/:id'];

export default DOCUMENTS;
